export default "__VITE_ASSET__ed178223__"